import { useState, useEffect } from 'react';
import callCenterErrorService from '../../services/callCenterErrorService';

const useCallCenterErrorModal = () => {
  const [errorData, setErrorData] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const unsubscribe = callCenterErrorService.subscribe((error) => {
      if (error) {
        setErrorData(error);
        setIsOpen(true);
      } else {
        setIsOpen(false);
        setErrorData(null);
      }
    });

    return () => {
      unsubscribe();
    };
  }, []);

  const toggle = () => {
    setIsOpen(false);
    callCenterErrorService.clearError();
  };

  return {
    errorData,
    isOpen,
    toggle
  };
};

export default useCallCenterErrorModal;
